// RelationshipSummary. Mirrors data-component="relationship-summary"
// from the approved HTML. Four-tile strip: horse portrait + totals,
// current barn, primary vet, primary farrier.
//
// TODO(runtime): hydrate from services/relationships.summarize once
// the HTTP endpoint lands. Portrait is served from services/horse-
// timeline (same source as the HorseProfile card).
import type { ReactNode } from 'react';
import { HORSE_PORTRAIT_PLACEHOLDER } from '../../../data/mockData.js';
import type { RelationshipSummary as RelationshipSummaryData } from '../mockData.js';

export interface RelationshipSummaryProps {
  summary: RelationshipSummaryData;
  portraitUrl?: string;
}

export function RelationshipSummary({
  summary,
  portraitUrl,
}: RelationshipSummaryProps): ReactNode {
  return (
    <section
      className="relationship-summary-strip"
      data-component="relationship-summary"
    >
      <div className="summary-media">
        {portraitUrl !== '' && <img
          src={portraitUrl ?? HORSE_PORTRAIT_PLACEHOLDER}
          alt={`Reference portrait for ${summary.horseName}`}
        />}
        <div>
          <span>{summary.horseName.toUpperCase()}&rsquo;S CARE TEAM</span>
          <strong>{summary.currentCount} current connections</strong>
          <small>{summary.formerSummary}</small>
        </div>
      </div>
      <div className="summary-stat">
        <span>CURRENT BARN</span>
        <strong>{summary.currentBarn.name}</strong>
        <small>
          {summary.currentBarn.location} &middot; {summary.currentBarn.since}
        </small>
      </div>
      <div className="summary-stat">
        <span>PRIMARY VET</span>
        <strong>{summary.primaryVet.name}</strong>
        <small>{summary.primaryVet.practice}</small>
      </div>
      <div className="summary-stat">
        <span>PRIMARY FARRIER</span>
        <strong>{summary.primaryFarrier.name}</strong>
        <small>{summary.primaryFarrier.cadence}</small>
      </div>
    </section>
  );
}
